import { Avatar, Badge, Tooltip } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { getRandomColorsBassedOnLetters } from '../../../../../../helper/colors';
const OnlineUserList = ({ size = 'large', count = 3 }) => {
  const { teamMembers, activeUsers, activeEndUsers } = useSelector(
    (state) => state.inbox,
  );
  const { currentUser, isSocketConnected } = useSelector((state) => state.app);

  return (
    <Avatar.Group
      size={size}
      max={{
        count,
        style: { color: '#f56a00', backgroundColor: '#fde3cf' },
      }}
    >
      {teamMembers.map((user) => {
        const isOnline = activeUsers.some(
          (activeUser) => activeUser.user_id == user.user_id,
        );
        const isMe = user.user_id == currentUser?.id;
        const AmIOnline = isMe && isSocketConnected;
        const { color, backgroundColor } = getRandomColorsBassedOnLetters(
          user?.screen_name?.slice(0, 1).toUpperCase(),
        );
        return (
          <Tooltip title={isMe ? 'You' : user?.screen_name} key={user.user_id}>
            <Badge
              count={1}
              dot
              offset={config[size].offset}
              color={isOnline || AmIOnline ? '#87d068' : '#ccc'}
            >
              <Avatar
                src={user?.profile_photo}
                size={size}
                style={{
                  backgroundColor: color,
                  // color,
                  border:
                    isOnline || AmIOnline
                      ? '1px solid var(--new-primary)'
                      : '1px solid black',
                }}
              >
                {user?.screen_name?.slice(0, 1).toUpperCase()}
              </Avatar>
            </Badge>
          </Tooltip>
        );
      })}
    </Avatar.Group>
  );
};

export default OnlineUserList;

const config = {
  large: {
    offset: [-35, 33],
  },
  small: {
    offset: [-22, 21],
  },
  default: {
    offset: [-29, 27],
  },
};
